<template>
  <div class="breadcrumbWrap">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item v-if="former && former.meta">
        <el-button type="text" @click="back">返回</el-button>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="former" :to="{ path: former.path }">
        <el-button type="text">{{ former.meta.title }}</el-button>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-if="former && former.meta.former" :to="{ path: former.meta.former.path }">
        <el-button type="text">{{ now }}</el-button>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: 'breadcrumb',
  data() {
    return {
      now: undefined,
      path: undefined,
      former: undefined
    }
  },
  watch: {
    '$route': 'getTitle'
  },
  mounted() {
    this.getTitle()
  },
  methods: {
    getTitle() {
      setTimeout(() => {
        this.now = this.$route.meta.title
        this.path = this.$route.path
        if (this.$route.meta.former) {
          this.$set(this, 'former', this.$route.meta.former)
        } else {
          this.$set(this, 'former', undefined)
        }
      }, 10)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.breadcrumbWrap {
  display: flex;
  padding: 0 30px;
  height: 40px;
  line-height: 40px;
  /* background: #f7f7f7; */
  align-items: center;
}

.img {
  margin-right: 10px;
  height: 16px;
}
</style>
